import { IGetComboModifiersShort, IGetComboModifiersShortResponse } from 'types';
import { request } from '../index';

const serviceGetComboModifiersShort = (args: IGetComboModifiersShort): Promise<IGetComboModifiersShortResponse> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/ComboModifiers/shortByRestaurantIds`, data: args });
};

export { serviceGetComboModifiersShort };
